import { OptionsObject, SnackbarKey } from 'notistack';
import { ReactNode } from 'react';

export type PoolSnackbarType = 'success' | 'error' | 'fatal';

export interface PoolSnackbarData {
    message: string;
    notificationType: PoolSnackbarType;
    options?: OptionsObject;
    key: SnackbarKey;
    values?: Record<string, ReactNode>;
}

export class PoolSnackbar {
    public static error(message: string, values?: Record<string, ReactNode>): PoolSnackbarData {
        const key = new Date().getTime() + Math.random();
        return {
            message,
            notificationType: 'error',
            key,
            options: {
                variant: 'error',
                key,
            },
            values,
        };
    }

    public static fatal(): PoolSnackbarData {
        return {
            message: 'app.error.fatal',
            notificationType: 'fatal',
            key: 'fatal',
            options: {
                variant: 'error',
                key: 'fatal',
                persist: true,
            },
        };
    }

    public static success(message: string, values?: Record<string, ReactNode>): PoolSnackbarData {
        const key = new Date().getTime() + Math.random();
        return {
            message,
            notificationType: 'success',
            key,
            options: {
                variant: 'success',
                key,
            },
            values,
        };
    }
}
